import React, { PureComponent } from 'react'
import { Panel } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import { fleetsTab } from '../../../../constants/management/fleets'
import { Link } from 'react-router-dom'

class DossierHistoricalsFleetComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openDossierHistoricalPanel: true,
      dossiersLoaded: false,
      filters: {
        orderBy: '+number'
      }
    }
  }

  componentDidMount () {
    if (this.props.fleet && !this.props.create && this.state.openDossierHistoricalPanel) {
      this.props.actions.getDossierHistoricalsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true })
    }
  }

  collapsePanelDossierHistoricals () {
    this.setState({ openDossierHistoricalPanel: !this.state.openDossierHistoricalPanel })
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.fleet && !this.props.create && ((this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_HISTORICALS && this.state.openDossierHistoricalPanel) || (this.props.tabActiveKey === fleetsTab.FLEETS_HISTORICALS && this.state.openDossierHistoricalPanel && this.state.openDossierHistoricalPanel !== prevState.openDossierHistoricalPanel))) {
      this.props.actions.getDossierHistoricalsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true })
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.dossierHistoricalFleetDetails))
    dossiers = dossiers.sort(compareValues(field, order))
    this.props.actions.getDossierHistoricalsFleetSuccess(dossiers)
  }

  render () {
    const {
      t,
      dossierHistoricalFleetDetails
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const numDossiers = !this.state.dossiersLoaded ? '' : (dossierHistoricalFleetDetails ? dossierHistoricalFleetDetails.length : 0)
    let bar = !this.state.dossiersLoaded ? '' : ' | '
    let columnsTable = [
      <th key={0} data-field="number" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}DOSSIER_NUMBER`)}&nbsp;<i className={this.getIconClass('number')}></i>
      </th>,
      <th key={1} data-field="organizedUnit" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}ORGANIZED_UNIT`)}&nbsp;<i className={this.getIconClass('organizedUnit')}></i>
      </th>,
      <th key={2} data-field="client" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}CLIENT`)}&nbsp;<i className={this.getIconClass('client')}/>
      </th>,
      <th key={3} data-field="clientFinal" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}FINAL_CLIENT`)}&nbsp;<i className={this.getIconClass('clientFinal')}/>
      </th>,
      <th key={4} data-field="vinChassisLicensePlate" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}VEHICLE`)}&nbsp;<i className={this.getIconClass('vinChassisLicensePlate')}/>
      </th>,
      <th key={5} data-field="model" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}MODEL`)}&nbsp;<i className={this.getIconClass('model')}></i>
      </th>,
      <th key={6} data-field="salesMan" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}SALESMAN`)}&nbsp;<i className={this.getIconClass('salesMan')}/>
      </th>,
      <th key={7} data-field="stage" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}STAGE`)}&nbsp;<i className={this.getIconClass('stage')}/>
      </th>
    ]

    return (
      <>
        <div id="dossierHistoricalsFleetComponent">
          <div className="_nf dossier-panel" >
            <div className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelDossierHistoricals()}>

              <div className="name-wrapper fleet-panel-box-title">
                <h4>{t(`${tKey}DOSSIERS_STORED`)} {bar} <span className='fleet-panel-subTitle'>{numDossiers}</span> </h4>
              </div>

              <i className={this.state.openDossierHistoricalPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

            </div>
            <Panel expanded={this.state.openDossierHistoricalPanel} onToggle={() => {}}>
              <Panel.Collapse>
                <div id="fleet-dossier-details-table">
                  <SimpleTablePage
                    columns={columnsTable}
                    className='disabledTd'
                    rows={dossierHistoricalFleetDetails && dossierHistoricalFleetDetails.map((row, idx) => (
                      <tr key={idx}>
                        <td>
                          {
                            row.urlToNavigate ? (
                              <Link to={`/dossier${row.urlToNavigate}`}>
                                {row.number}
                              </Link>
                            ) : row.number
                          }
                        </td>
                        <td>{row.organizedUnit}</td>
                        <td>{row.client}</td>
                        <td>{row.clientFinal}</td>
                        <td>{row.vinChassisLicensePlate}</td>
                        <td>{row.model}</td>
                        <td>{row.salesMan}</td>
                        <td>{row.stage}</td>
                      </tr>
                    ))}
                  ></SimpleTablePage>
                </div>
              </Panel.Collapse>
            </Panel>
          </div>
        </div>
      </>
    )
  }
}

export default reduxForm({
  form: 'DossierHistoricalsFleetComponent'
})(DossierHistoricalsFleetComponent)
